import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store/index.js";
import "./filters.js"; // Carga de filtros para usar en el front
import mixin from "./mixin.js"; // Mixin anexados a Vue
import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "@fortawesome/fontawesome-free/css/all.css";
import Vuetify from "vuetify";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "vue-awesome/icons/caret-down";
import "vue-awesome/icons/trash-alt";
import "vue-awesome/icons/plane-departure";
import "vue-awesome/icons/plane-arrival";
import "vue-awesome/icons/arrow-right";
import "vue-awesome/icons/arrow-left";
import "vue-awesome/icons/user";
import "vue-awesome/icons/users";
import "vue-awesome/icons/medkit";
import "vue-awesome/icons/shopping-bag";
import "vue-awesome/icons/shopping-cart";
import "vue-awesome/icons/car-alt";
import "vue-awesome/icons/question";
import "vue-awesome/icons/check";
import "vue-awesome/icons/exclamation";
import "vue-awesome/icons/bed";
import "vue-awesome/icons/star";
import "vue-awesome/icons/angle-up";
import "vue-awesome/icons/angle-down";
import "vue-awesome/icons/brands/facebook-f";
import "vue-awesome/icons/brands/fort-awesome";
import "vue-awesome/icons/brands/twitter";
import "vue-awesome/icons/brands/youtube";
import "vue-awesome/icons/brands/instagram";
import "vue-awesome/icons/exclamation-triangle";
import "@/assets/css/estilos-as.css";
import "vue-loading-overlay/dist/vue-loading.css";
import "here-js-api/scripts/mapsjs-core";
import "here-js-api/scripts/mapsjs-service";
import "here-js-api/scripts/mapsjs-ui";
import "here-js-api/scripts/mapsjs-mapevents";
import "here-js-api/scripts/mapsjs-clustering";
import "here-js-api/scripts/mapsjs-places";
import VueCookies from "vue-cookies";
import VueAnalytics from "vue-analytics";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
import Icon from "vue-awesome/components/Icon";
import Loading from "vue-loading-overlay";
import PluginAs from "@/assets/js/plugins/PluginAs.js";
import VeeValidate, { Validator } from "vee-validate";
import es from "vee-validate/dist/locale/es";
import PassportHandler from "@/assets/js/class/PassportHandler.js";
import Toasted from "vue-toasted";

import IconMickey from "@/components/utiles/IconMickey.vue";
import VCalendar from "v-calendar";

import VueLodash from "vue-lodash";
const optionsdash = { name: "$lodash" };
Vue.use(VueCookies, { expires: "20m" });

Vue.use(VueLodash, optionsdash);
import { debounce } from "debounce";
import VueClazyLoad from "vue-clazy-load"; // ES6 (Babel and others)
Vue.use(VueClazyLoad);
Vue.use(Toasted);
Vue.use(VueAnalytics, { id: "UA-28639533-1", router });
Vue.use(VCalendar, {
  componentPrefix: "vc" // Use <vc-calendar /> instead of <v-calendar />
});

Vue.use(Vuetify, {
  icons: {
    "mickey-as": {
      component: IconMickey // you can use string here if component is registered globally
    }
  }
});

// Declaracion de validacion de DNIs duplicados personalizados, el mensaje no funciona
Validator.extend("dni", {
  getMessage(field, args) {
    return "retorno mensaje";
  },
  validate: (field, args) => {
    if (args.every(a => a === "undefined")) {
      return false;
    }
    const argumento = JSON.parse(args.join());
    const validoPax =
      argumento.pasajeros.filter(p => p.dni == field).length < 2 ? true : false;
    const validoSel = !argumento.seleccionados.some(s => s.dni == field);
    return validoPax && validoSel;
  }
});
///////////////////////////////////////////////////////////
Vue.use(VeeValidate, {
  classes: true
});

Validator.localize("es", es);
Vue.use(Loading);
Vue.use(PluginAs);
Vue.use(BootstrapVue);
Vue.use(VueMoment, {
  moment
});
Vue.mixin(mixin);

Vue.config.productionTip = process.env.NODE_ENV !== "production";
Vue.config.performance = process.env.NODE_ENV !== "production";
//Vue.component('v-icon', Icon);  27082019

var vue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
vue.$passporthandler.setRouter(vue.$router);
vue.$axiosHandlerAs.setPassportHandler(vue.$passporthandler);

// Validacion de logueo requerido
router.beforeEach(
  debounce((to, from, next) => {
    window.scrollTo(0, 0);
    if (!to.meta.requiresAuth) {
      next();
      return;
    }
    if (vue.$passporthandler.getAutenticando()) {
      // Para evitar pedir dos veces o mas si el token es valido al mismo tiempo
      next();
      return;
    }
    vue.$passporthandler.isAuth().then(function(value) {
      if (value.auth) {
        vue.$cookies.set("auth", vue.$passporthandler.getUsuario(), 1000);
        next();
        return;
      }
      vue.$toasted.show(value.detalle, {
        theme: "toasted-primary",
        position: "top-right",
        duration: 2000,
        type: "error"
      });
      vue.$passporthandler.removePassport();
      next({ name: "login" });
    });
  }, 10)
);
if (window.Cypress) {
  // only available during E2E tests
  window.app = vue;
}
